module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Aviator-Playful-V1.151e20ff.jpeg";